import axios from 'axios'
import './common'

export default {
    getList: (params) => axios.get(`/circles`, { params: params }),
    get: (id) => axios.get(`/circles/${id}`),
    create: (data) => axios.post(`/circles`, data),
    update: (id, data) => axios.put(`/circles/${id}`, data),
    delete: (id) => axios.delete(`/circles/${id}`),
    join: (id) => axios.post(`/circles/${id}/join`),
    leave: (id) => axios.delete(`/circles/${id}/leave`),
    followings: () => axios.get(`/circles/followings`),
}